export const AnalyticsEvent = {
  OfferImageGenerated: 'offer_image_generated',
  OfferImageDiscarded: 'offer_image_discarded',
  SmartPricingRuleImageGenerated: 'smart_pricing_rule_image_generated',
  SmartPricingRuleImageDiscarded: 'smart_pricing_rule_image_discarded',
  CashbackBonusImageGenerated: 'cashback_bonus_image_generated',
  CashbackBonusImageDiscarded: 'cashback_bonus_image_discarded',
  PromoCodeImageGenerated: 'promo_code_image_generated',
  PromoCodeImageDiscarded: 'promo_code_image_discarded',
};

export const GenerationStatus = {
  Success: 'success',
  Failed: 'failed',
  Timeout: 'timeout',
  RateLimited: 'rate_limited',
};

export const RegenerationReason = {
  WrongStyle: 'wrong_style',
  WrongColors: 'wrong_colors',
  WrongFoodItem: 'wrong_food_item',
  LowQuality: 'low_quality',
  DoesntMatchBrand: 'doesnt_match_brand',
  TextIssues: 'text_issues',
  Other: 'other',
};

export const DiscardAction = {
  Removed: 'removed',
  ReplacedWithUpload: 'replaced_with_upload',
};
